export default class SimpleVideo {
    constructor($root) {
        this.$root = $root;
        this.$video = this.$root.querySelector('video');
        this.$playback = this.$root.querySelector('.video-playback');
        this.$playbackProgress = this.$playback.querySelector('.video-playback_progress');

        this.playbackWidth = this.$playback.offsetWidth;

        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$root.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.$video.paused) {
                this.$video.play();
            } else {
                this.$video.pause();
            }
        });

        this.$video.addEventListener('playing', (e) => {
            this.$root.classList.add('-playing');
            this.playbackWidth = this.$playback.offsetWidth;
        });

        this.$video.addEventListener('pause', (e) => {
            this.$root.classList.remove('-playing');
        });

        this.$video.addEventListener('timeupdate', (e) => {
            this.$playbackProgress.style.width = this.$video.currentTime / this.$video.duration * this.playbackWidth + 'px';
        });
    }

    pause() {
        this.$video.pause();
    }
}